import '@fancyapps/fancybox';
export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery('.wp-block-gallery img').fancybox({
      arrows: true,
      buttons: [
        'zoom',
        'fullScreen',
        'close',
      ],
      thumbs: {
        autoStart: true,
      },
    }).attr('data-fancybox', 'image-gallery-group');

    $(".open-mobile-nav").click(function () {
      $(".nav-wrapper").removeClass("hidden");
    });

    $(".close-mobile-nav").click(function () {
      $(".nav-wrapper").addClass("hidden");
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js